<template>
  <div class="ui left aligned container">
    <div class="form">
      <h2>上传文件</h2>
      <form class="ui form">
        <RadioBox inline v-model="type" :options="options">类型</RadioBox>
        <div class="field">
          <input type="file" accept=".txt" @change="uploadFile" ref="file">
        </div>
        <button class="ui primary button" @click.prevent="submitFile" :disabled="!file">上传</button>
      </form>
    </div>
    <div class="divider"></div>

    <div class="ui right aligned container">
      <button @click="refresh" class="ui icon button"><i class="sync icon"></i></button>
      <button @click="addTexts" class="ui icon button"><i class="add icon"></i></button>
    </div>

    <vuetable ref="vuetable" :api-url="'/texts?type='+type" :fields="fields"
              @vuetable:pagination-data="onPaginationData">
      <template slot="actions" scope="props">
        <i class="edit link icon" title="编辑" @click="editTexts(props.rowData)"></i>
        &nbsp;&nbsp;
        <i class="trash alternate outline link icon" title="删除" @click="deleteTexts(props.rowData)"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <Modal v-model="modal">
      <template slot="title">
        {{title}}
      </template>
      <form class="ui form">
        <div class="field">
          <label>名称</label>
          <input name="name" type="text" v-model="form.name">
        </div>
        <RadioBox inline v-model="form.type" :options="options">类型</RadioBox>
        <div class="field">
          <label>文案</label>
          <textarea name="texts" v-model="form.texts" rows="25" cols="50"></textarea>
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">保存</div>
      </template>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import Vuetable from "@/table/Vuetable.vue";
import RadioBox from "@/components/RadioBox.vue";
import VuetablePagination from "@/table/VuetablePagination.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "Texts",
  components: {
    Vuetable,
    VuetablePagination,
    RadioBox,
    Modal
  },
  data() {
    return {
      type: 1,
      file: null,
      modal: false,
      title: '',
      form: {
        id: 0,
        name: '',
        type: 1,
        texts: ''
      },
      fields: [
        {name: 'id', title: 'ID'},
        {name: 'name', title: '名称'},
        {name: 'type', title: '类型', callback: 'showType'},
        {name: 'version', title: '版本'},
        {name: 'count', title: '数量'},
        {name: '__slot:actions', title: '操作'}
      ],
      options: [
        {key: 1, value: 1, text: "表情"},
        {key: 2, value: 2, text: "弹幕"},
        {key: 3, value: 3, text: "评论"},
        {key: 4, value: 4, text: "标签"},
        {key: 5, value: 5, text: "emoji"},
      ],
    }
  },
  methods: {
    refresh: function () {
      this.$refs.vuetable.reload();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage(page) {
      if (page === 'prev') {
        this.page--
      } else if (page === 'next') {
        this.page++
      } else {
        this.page = parseInt(page)
      }
      this.$refs.vuetable.changePage(page)
    },
    showType(value) {
      return this.options.find(e => e.value == value).text
    },
    addTexts() {
      this.title = '添加文案'
      this.form = {
        id: '',
        name: '',
        type: 1,
        texts: ''
      }
      this.modal = true
    },
    editTexts(text) {
      this.title = '更新文案'
      axios.get('/texts/' + text.id).then(({data}) => {
        this.form.id = data.id
        this.form.name = data.name
        this.form.type = data.type
        this.form.texts = data.texts.join('\n')
        this.modal = true
      })
    },
    onSubmit() {
      axios.post('/texts/' + this.form.id, {
        name: this.form.name,
        type: this.form.type,
        texts: this.form.texts.split('\n')
      }).then((res) => {
        this.type = this.form.type
        this.modal = false
        this.refresh();
      });
    },
    deleteTexts(data) {
      axios.delete('/texts/' + data.id).then(() => {
        this.refresh();
      })
    },
    uploadFile(e) {
      console.log(e)
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.file = files[0];
    },
    submitFile() {
      const formData = new FormData();
      formData.append('file', this.file);
      const headers = {'Content-Type': 'multipart/form-data'};
      axios.post('/texts/upload?type=' + this.type, formData, {headers}).then((res) => {
        this.file = null
        this.refresh();
      });
    }
  }
}
</script>

<style scoped>

</style>